export default __webpack_public_path__ + "static/media/TheElements _05.71177180.png";